import { render, staticRenderFns } from "./ParkingAndDescription.vue?vue&type=template&id=335d7c88"
import script from "./ParkingAndDescription.vue?vue&type=script&lang=js"
export * from "./ParkingAndDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports